import React, { Component } from 'react'
import StyleSheet from 'styles'
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

export class SelectionCounter extends Component{

  static defaultProps = {
    onClear: () => {},
    selectionType: 'users'
  }

  get hasSelection(){
    return !!this.selectedCount
  }

  get selectedCount(){
    return Object.values(this.props.selection).filter(x => x).length
  }

  render = () =>
     <div className={styles('currentSelection', {currentSelectionActive: this.hasSelection})}>
      <div className={styles('currentSelectionBackground', {currentSelectionBackgroundActive: this.hasSelection})}>
        <Typography className={styles.currentSelectionText} variant='body1'>{this.selectedCount} {this.props.selectionType} selected</Typography>
        <Tooltip title="Clear Selection" placement="bottom-end">
          <IconButton className={styles.currentSelectionButton} onClick={this.props.onClear}>
            <CloseIcon/>
          </IconButton>
        </Tooltip>
      </div>
    </div>
}

const styles = StyleSheet({
   currentSelection: {
    height: 0,
    transition: 'all 200ms',
    marginBottom: 10,
    overflow: 'hidden'
  },
  currentSelectionActive: {
    height: 40,
  },
  currentSelectionBackground: {
    background: '#d88212',
    border: '1px solid #933e00',
    padding: 10,
    opacity: 0,
    transition: 'all 1000ms',
    display: 'flex'
  },
  currentSelectionBackgroundActive: {
    opacity: 1.0
  },
  currentSelectionText: {
    flex: 1,
    marginTop: 0
  },
  currentSelectionButton: {
    width: 24,
    height: 24,
    marginTop: -3
  },
})
export default SelectionCounter